import type { RsvpErrors, RsvpPayload } from '@/types'

export const RSVP_LIMITS = {
    name: 80,
    email: 160,
    dietary: 300,
    song: 120,
    message: 1000
} as const

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

// Shared by the form and the API route so both sides validate exactly the same way.
export const validateRsvp = ({ name, email, attending }: Pick<RsvpPayload, 'name' | 'email' | 'attending'>): RsvpErrors => {
    const errors: RsvpErrors = {}

    if (name.trim().length < 2) errors.name = "Indiquez votre prénom et votre nom."
    if (!EMAIL_PATTERN.test(email.trim())) errors.email = "Indiquez une adresse e-mail valide."
    if (attending === null) errors.attending = "Dites-moi si vous serez présent·e."

    return errors
}

export const firstName = (name: string): string => name.trim().split(/\s+/)[0] ?? ''
